// mainImageResource — central per-resource-type routing + edit-permission for the
// "main image" (default image) feature, shared by the document manager (Document.jsx,
// where a document is marked/unmarked as the main image) and the thumbnail renderer
// (MainImageThumbnail.jsx).
//
// Marking a main image is part of EDITING the owning resource (RN17 / S38), so it is
// gated by that resource's EDIT permission, not by the document permissions. Extending
// the feature to a new resource type is just a new entry here — plus the matching Sun
// endpoints.
//
// Sun endpoints per resource (batch main-image lookup, mark, remove, thumbnail):
//   PART_REFERENCE: POST partReferences/mainImages
//                   PUT/DELETE/GET partReference/{id}/mainImage[/{uuid}|/thumbnail]
//   DEVICE (requested, see mic-user-stories sun-contract): POST devices/mainImages
//                   PUT/DELETE/GET device/{id}/mainImage[/{uuid}|/thumbnail]
const MAIN_IMAGE_RESOURCES = {
  PART_REFERENCE: {
    editPermission: 'EDIT_PART_REFERENCE',
    batchEndpoint: 'partReferences/mainImages',
    base: (id) => 'partReference/' + id + '/mainImage'
  },
  DEVICE: {
    editPermission: 'PROPERTIES_DEVICE',
    batchEndpoint: 'devices/mainImages',
    base: (id) => 'device/' + id + '/mainImage'
  }
}

/**
 * @param {string} resourceType e.g. 'PART_REFERENCE' | 'DEVICE'
 * @returns {{editPermission: string, batchEndpoint: string, base: (id) => string}|null}
 *   the main-image config for this resource, or null when the resource does not
 *   support a main image (the feature is then hidden).
 */
function mainImageResource (resourceType) {
  return MAIN_IMAGE_RESOURCES[resourceType] || null
}

export { MAIN_IMAGE_RESOURCES, mainImageResource }
